import { LoadedError, logger } from '$utils'

export const errorHandler = async (response: Response) => {
  const [hasJsonBody, errorBody, responseStatus] = await response
    .clone()
    .json()
    .then((result) => [true, result, response.status])
    .catch(async () => {
      if (response.status === 404) {
        return [false, 'URL Not Found', response.status]
      }

      return [false, await response.text(), response.status]
    })

  logger.error('Error: %o', errorBody)
  if (hasJsonBody && errorBody.id && errorBody.code && errorBody.description) {
    throw new LoadedError(
      errorBody.id,
      errorBody.code,
      errorBody.description,
      errorBody.messages,
      responseStatus
    ) // Return the typed error
  }

  throw new Error('API client exception')
}
